/**
 * extend tmpl object
 **/
define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var utils = require('utils');
    var i18n = require('i18n');
    var user = require('user');
    var device = require('util/device.util');
    var tmpl = require('templates');
    var config = require('config');
    var dompurify = require('dompurify');

    tmpl.i18n = i18n.t.bind(i18n);
    tmpl.i18nExt = i18n.tExt.bind(i18n);
    tmpl.utils = utils;
    tmpl.device = device;
    tmpl.sanitize = dompurify.sanitize;
    tmpl.user = user;
    tmpl._ = _;
    tmpl.dateFormat = config.get('dateFormat');

    /**
     * @param {string} text
     * @return {string}
     **/
    tmpl.highlightLinks = function(text) {
        var content = $('<div/>').html(text),
            newMessage = _getText(content),
            parts = newMessage.split(/\s+/),
            detectionRules = {
                isEmail: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                isAbsoluteLink: /\(?(?:(http|https|ftp):\/\/)?(?:((?:[^\W\s]|\.|-|[:]{1})+)@{1})?((?:www.)?(?:[^\W\s]|\.|-)+[\.][^\W\s]{2,4}|localhost(?=\/)|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::(\d*))?([\/]?[^\s\?]*[\/]{1})*(?:\/?([^\s\n\?\[\]\{\}\#]*(?:(?=\.)){1}|[^\s\n\?\[\]\{\}\.\#]*)?([\.]{1}[^\s\?\#]*)?)?(?:\?{1}([^\s\n\#\[\]]*))?([\#][^\s\n]*)?\)?/,
                isMobilePhone: /(\+?(\d{1,3})?([ -])?(\(\d+\))?[ -]?(\d[ -]?){6,11}\d)/g,
                isLinkProtocol: /(?:(http|https|ftp):\/\/)/,
                isCarriageReturn: /[\n\r]/g
            };

        parts.forEach(function(part) {
            if (detectionRules.isEmail.test(part)) { // detect emails
                text = text.replace(part, '<a href="mailto:' + part + '" target="_blank">' + part + '</a>');
            }
            else {
                if (detectionRules.isAbsoluteLink.test(part)) { //// detect absolute links
                    if (detectionRules.isLinkProtocol.test(part)) {
                        text = text.replace(part, '<a href="' + part + '" target="_blank">' + part + '</a>');
                    } else if (part.substr(0, 3) === 'www') {
                        text = text.replace(part, '<a href="http://' + part + '" target="_blank">' + part + '</a>');
                    }
                }
                else if (part[0] === '/') { // detect relative links
                    text = text.replace(part, '<a href="http://' + part + '">' + part + '</a>');
                }
            }
        });

        // detect mobile phones numbers
        text = text.replace(detectionRules.isMobilePhone, '<a href="tel:$1">$1</a>');

        // detect carriage return
        text = text.replace(detectionRules.isCarriageReturn, '<br>');
        return text;
    };

    /**
     * @param {NodeList} elements
     * @return {string}
     **/
    function _getText(elements) {
        var result = '',
            nodeTypes = {
                text: 3,
                cdata: 4,
                comment: 8
            };

        [].forEach.call(elements, function(elem) {
            if (elem.nodeType === nodeTypes.text || elem.nodeType === nodeTypes.cdata) {
                result += elem.nodeValue;
            } else if (elem.nodeType !== nodeTypes.comment) { // Traverse everything else, except comment nodes
                result += _getText(elem.childNodes);
            }
        });

        return result;
    }

    module.exports = tmpl;
});
